import { Box } from '@chakra-ui/layout';
import { Icon, TIconName } from 'components';
import { IIcon } from 'components/Icon/icons';
import useEventBus from 'hooks/useEventBus';
import React, { memo, useCallback } from 'react';

// import { Container } from './styles';

interface IProps {
  tip?: string | JSX.Element;
  iconName?: TIconName;
  $iconColor?: IIcon['$iconColor'];
}

const TooltipComp: React.FC<IProps> = ({ tip, iconName, $iconColor }) => {
  const eventBus = useEventBus();
  const handlePopup = useCallback(() => {
    eventBus.dispatchEvent('onPopup', { text: tip, title: 'Ajuda' });
  }, [eventBus, tip]);
  return (
    <Box
      as="button"
      type="button"
      bg="transparent"
      border="none"
      transform="opacity ease-in 120ms"
      _hover={{ opacity: 0.8 }}
      ml="10px"
      flexShrink={0}
      justifySelf="flex-end"
      onClick={handlePopup}
    >
      <Icon color={$iconColor || 'gray600'} name={iconName || 'questionCircle'} size={1} />
    </Box>
    //   <Tooltip
    //   closeDelay={300}
    //   bgColor="white"
    //   textColor="black"
    //   padding="10px"
    //   borderRadius="8px"
    //   shadow="md"
    //   placement="top-start"
    //   aria-label="Tooltip Help"
    //   label={tip}
    // >
    // </Tooltip>
  );
};

export const Tooltip = memo(TooltipComp);
